export enum PaymentType {
  RENT = 'RENT',
  PARKING = 'PARKING',
  HEATING_PREPAYMENT = 'HEATING_PREPAYMENT',
  SERVICE_PAYMENT = 'SERVICE_PAYMENT',
  OTHER = 'OTHER',
  TOTAL_RENT = 'TOTAL_RENT',
}
